// import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
// import './SelectBoxWithSearch.css'

// const SearchSelectBox = ({
//   options = [],
//   onChange,
//   defaultValue = '',
//   label = '',
//   className = '',
//   border = '' ,
//   error ,
//   disabled = false,
//   important = false,
//   source=false,
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selected, setSelected] = useState(null);
//   const dropdownRef = useRef(null);
//   const [openUpward, setOpenUpward] = useState(false);

//   // Memoize options map for faster lookups
//   const optionsMap = useMemo(() => {
//     const map = new Map();
//     // Safety check: ensure options is an array
//     if (Array.isArray(options)) {
//       options.forEach(option => {
//         if (option && typeof option.label === 'string') {
//           map.set(option.value, option);
//         }
//       });
//     }

//     return map;
//   }, [options]);

//   // Initialize selected value based on defaultValue
//   useEffect(() => {
//     if (defaultValue !== null && defaultValue !== undefined && defaultValue !== '') {
//       // Handle both string and number comparisons
//       const matchedOption = optionsMap.get(defaultValue) ||
//                            optionsMap.get(String(defaultValue)) ||
//                            optionsMap.get(Number(defaultValue));

//       if (matchedOption) {
//         setSelected(matchedOption);
//       } else {
//         setSelected(null);
//       }
//     } else {
//       setSelected(null);
//     }
//   }, [defaultValue, optionsMap]);

//   // Memoized filtered options with debouncing effect
//   const filteredOptions = useMemo(() => {
//     if (!searchTerm.trim()) {
//       return Array.from(optionsMap.values());
//     }

//     const searchLower = searchTerm.toLowerCase();
//     return Array.from(optionsMap.values()).filter(option =>
//       option.label.toLowerCase().includes(searchLower)
//     );
//   }, [searchTerm, optionsMap]);

//   // Memoized select handler to prevent unnecessary re-renders
//   const handleSelect = useCallback((option) => {
//     if (disabled) return; // Prevent selection when disabled

//     setSelected(option);
//     setIsOpen(false);
//     setSearchTerm('');

//     if (onChange) {
//       onChange({
//         target: {
//           value: option.value
//         }
//       });
//     }
//   }, [onChange, disabled]);

//   // Memoized search handler
//   const handleSearch = useCallback((e) => {
//     setSearchTerm(e.target.value);
//   }, []);

//   // // Memoized toggle handler
//   // const handleToggle = useCallback(() => {
//   //   if (disabled) return; // Prevent opening when disabled
//   //   setIsOpen(prev => !prev);
//   // }, [disabled]);

// // Check available space when opening
//   const handleToggle = useCallback(() => {
//     if (disabled) return;

//     if (!isOpen && dropdownRef.current) {
//       const rect = dropdownRef.current.getBoundingClientRect();
//       const spaceBelow = window.innerHeight - rect.bottom;
//       const spaceAbove = rect.top;
//       const dropdownHeight = 250; // approximate dropdown height

//       setOpenUpward(spaceBelow < dropdownHeight && spaceAbove > spaceBelow);
//     }

//     setIsOpen(prev => !prev);
//   }, [disabled, isOpen]);

//   // Click outside handler
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsOpen(false);
//         setSearchTerm('');
//       }
//     };

//     if (isOpen) {
//       document.addEventListener('mousedown', handleClickOutside);
//       return () => document.removeEventListener('mousedown', handleClickOutside);
//     }
//   }, [isOpen]);

//   // Keyboard navigation
//   const handleKeyDown = useCallback((e) => {
//     if (!isOpen) return;

//     if (e.key === 'Escape') {
//       setIsOpen(false);
//       setSearchTerm('');
//     }
//   }, [isOpen]);

//   useEffect(() => {
//     if (isOpen) {
//       document.addEventListener('keydown', handleKeyDown);
//       return () => document.removeEventListener('keydown', handleKeyDown);
//     }
//   }, [isOpen, handleKeyDown]);

//   useEffect(() => {
//     if (source === true) {
//       console.log("Default", defaultValue);
//       console.log('Options',options)
//     }
//   }, [defaultValue, source,options]);

//   return (
//     <div
//       className={`search-select-dropdown-container ${className} ${disabled ? 'disabled' : ''}`}
//       ref={dropdownRef}
//     >
//       <div
//         className={`search-select-dropdown-header ${error ? 'input-error' : ''} ${border}`}
//         onClick={handleToggle}
//       >
//         <div className="floating-label-wrapper">
//           <label className={`search-select-label common-text color-999 ftw-4 ${selected ? 'has-value' : ''}`}>
//             {label}
//             {important && <span className="required-asterisk">*</span>}
//           </label>
//           <span className="selected-value ftw-4 common-text">
//             {selected?.label || ''}
//           </span>
//         </div>
//         <svg
//           className={`search-select-dropdown-arrow ${isOpen ? 'search-select-open' : ''}`}
//           width="8"
//           height="6"
//           viewBox="0 0 8 6"
//           fill="none"
//           xmlns="http://www.w3.org/2000/svg"
//         >
//           <path d="M4 6L0.535899 0L7.4641 0L4 6Z" fill="#424242"/>
//         </svg>
//       </div>

//       {isOpen && !disabled && (
//         <div className={`search-select-dropdown-panel ${openUpward ? 'open-upward' : ''}`}>
//           <div className="search-select-search-container">
//             <svg
//               className="search-select-search-icon"
//               width="16"
//               height="16"
//               viewBox="0 0 16 16"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 d="M11.8889 11.8889L15 15M1 7.22222C1 8.87246 1.65555 10.4551 2.82245 11.622C3.98934 12.7889 5.57199 13.4444 7.22222 13.4444C8.87246 13.4444 10.4551 12.7889 11.622 11.622C12.7889 10.4551 13.4444 8.87246 13.4444 7.22222C13.4444 5.57199 12.7889 3.98934 11.622 2.82245C10.4551 1.65555 8.87246 1 7.22222 1C5.57199 1 3.98934 1.65555 2.82245 2.82245C1.65555 3.98934 1 5.57199 1 7.22222Z"
//                 stroke="#424242"
//                 strokeWidth="1.5"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               />
//             </svg>
//             <input
//               type="text"
//               value={searchTerm}
//               onChange={handleSearch}
//               className="search-select-search-input  ftw-4 common-text"
//               placeholder="Search..."
//               autoFocus
//             />
//           </div>

//           <div className="search-select-options-container">
//             {filteredOptions.length > 0 ? (
//               filteredOptions.map((option) => (
//                 <div
//                   key={option.value}
//                   className="search-select-option-item ftw-4 dk-gray common-text"
//                   onClick={() => handleSelect(option)}
//                 >
//                   {option.label}
//                 </div>
//               ))
//             ) : (
//               <div className="search-select-no-results ftw-4 color-999 common-text">
//                 No results found
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SearchSelectBox;

import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import "./SelectBoxWithSearch.css";
import { useTranslation } from "react-i18next";

const SearchSelectBox = ({
  options = [],
  onChange,
  defaultValue = "",
  label = "",
  className = "",
  border = "",
  error,
  disabled = false,
  important = false,
  source = false,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selected, setSelected] = useState(null);
  const dropdownRef = useRef(null);
  const [openUpward, setOpenUpward] = useState(false);

  // Memoize options map for faster lookups
  const optionsMap = useMemo(() => {
    const map = new Map();
    // Safety check: ensure options is an array
    if (Array.isArray(options)) {
      options.forEach((option) => {
        if (option && typeof option.label === "string") {
          map.set(option.value, option);
        }
      });
    }

    return map;
  }, [options]);

  // Initialize selected value based on defaultValue
  useEffect(() => {
    if (
      defaultValue !== null &&
      defaultValue !== undefined &&
      defaultValue !== ""
    ) {
      // Handle both string and number comparisons
      const matchedOption =
        optionsMap.get(defaultValue) ||
        optionsMap.get(String(defaultValue)) ||
        optionsMap.get(Number(defaultValue));

      if (matchedOption) {
        setSelected(matchedOption);
      } else {
        setSelected(null);
      }
    } else {
      setSelected(null);
    }
  }, [defaultValue, optionsMap]);

  // Memoized filtered options with debouncing effect
  const filteredOptions = useMemo(() => {
    if (!searchTerm.trim()) {
      return Array.from(optionsMap.values());
    }

    const searchLower = searchTerm.toLowerCase();
    return Array.from(optionsMap.values()).filter((option) =>
      option.label.toLowerCase().includes(searchLower),
    );
  }, [searchTerm, optionsMap]);

  // Memoized select handler to prevent unnecessary re-renders
  const handleSelect = useCallback(
    (option) => {
      if (disabled) return; // Prevent selection when disabled

      setSelected(option);
      setIsOpen(false);
      setSearchTerm("");

      if (onChange) {
        onChange({
          target: {
            value: option.value,
          },
        });
      }
    },
    [onChange, disabled],
  );

  // Memoized search handler
  const handleSearch = useCallback((e) => {
    setSearchTerm(e.target.value);
  }, []);

  // Check available space when opening
  const handleToggle = useCallback(() => {
    if (disabled) return;

    if (!isOpen && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      const dropdownHeight = 250; // approximate dropdown height

      setOpenUpward(spaceBelow < dropdownHeight && spaceAbove > spaceBelow);
    }

    setIsOpen((prev) => !prev);
  }, [disabled, isOpen]);

  // Click outside handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm("");
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [isOpen]);

  // Keyboard navigation
  const handleKeyDown = useCallback(
    (e) => {
      if (!isOpen) return;

      if (e.key === "Escape") {
        setIsOpen(false);
        setSearchTerm("");
      }
    },
    [isOpen],
  );

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
      return () => document.removeEventListener("keydown", handleKeyDown);
    }
  }, [isOpen, handleKeyDown]);

  useEffect(() => {
    if (source === true) {
      console.log("Default", defaultValue);
      console.log("Options", options);
    }
  }, [defaultValue, source, options]);

  return (
    <div
      className={`search-select-dropdown-container ${className} ${disabled ? "disabled" : ""}`}
      ref={dropdownRef}
    >
      <div
        className={`search-select-dropdown-header ${error ? "input-error" : ""} ${border}`}
        onClick={handleToggle}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            handleToggle();
          }
        }}
      >
        <div className="floating-label-wrapper">
          <label
            className={`search-select-label common-text color-999 ftw-4 ${selected ? "has-value" : ""}`}
          >
            {t(label)}
            {important && <span className="required-asterisk">*</span>}
          </label>
          <span className=" fts-14 ftw-4 common-text black">
            {selected && (
              <>
                {selected.flag && (
                  <img
                    src={selected.flag}
                    alt=""
                    className="search-select-flag-icon"
                  />
                )}
                {selected.label}
              </>
            )}
          </span>
        </div>
        <svg
          className={`search-select-dropdown-arrow ${isOpen ? "search-select-open" : ""}`}
          width="8"
          height="6"
          viewBox="0 0 8 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M4 6L0.535899 0L7.4641 0L4 6Z" fill="#424242" />
        </svg>
      </div>

      {isOpen && !disabled && (
        <div
          className={`search-select-dropdown-panel ${openUpward ? "open-upward" : ""}`}
        >
          <div className="search-select-search-container">
            <svg
              className="search-select-search-icon"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8889 11.8889L15 15M1 7.22222C1 8.87246 1.65555 10.4551 1.82245 11.622C3.98934 12.7889 5.57199 13.4444 7.22222 13.4444C8.87246 13.4444 10.4551 12.7889 11.622 11.622C12.7889 10.4551 13.4444 8.87246 13.4444 7.22222C13.4444 5.57199 12.7889 3.98934 11.622 2.82245C10.4551 1.65555 8.87246 1 7.22222 1C5.57199 1 3.98934 1.65555 2.82245 2.82245C1.65555 3.98934 1 5.57199 1 7.22222Z"
                stroke="#424242"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearch}
              className="search-select-search-input  ftw-4 common-text"
              placeholder={t("Search...")}
              autoFocus
            />
          </div>

          <div className="search-select-options-container">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <div
                  key={option.value}
                  className={`search-select-option-item ftw-4 dk-gray common-text ${
                    selected && selected.value === option.value
                      ? "selected"
                      : ""
                  }`}
                  onClick={() => handleSelect(option)}
                >
                  {option.flag && (
                    <img
                      src={option.flag}
                      alt=""
                      className="search-select-flag-icon"
                    />
                  )}
                  {option.label}
                </div>
              ))
            ) : (
              <div className="search-select-no-results ftw-4 color-999 common-text">
                {t("No results found")}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchSelectBox;
